export default __webpack_public_path__ + "static/B0208-9e9f1aad8803fd96f9281af6d686db88.png";